import { createFileRoute } from '@tanstack/react-router';

import { DmOfferSetupComplete } from 'src/apps/checkout/app/pages/DmOffer.SetupComplete';

export const Route = createFileRoute(
  '/_auth/_only-header/store/dm-offer/setup-complete'
)({
  component: () => <DmOfferSetupComplete />,
});
